import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export function FirefoxIcon(props: SvgIconProps) {
  return (
    <SvgIcon width='97' height='100' viewBox='0 0 97 100' fill='none' {...props}>
      <path
        d='M93.2889 33.5384C91.1841 28.4739 86.918 23.0062 83.5712 21.2764C86.297 26.6191 87.8736 31.982 88.4764 35.982C88.4764 35.9699 88.4805 35.992 88.4845 36.0263L88.4926 36.0787C93.0651 48.4718 90.5732 61.0746 86.9845 68.7762C81.4321 80.6915 67.9926 92.9032 46.9504 92.3044C24.2166 91.6632 4.1884 74.7984 0.450509 52.7017C-0.230941 49.2178 0.450509 47.4497 0.79325 44.6211C0.375912 46.7985 0.216639 47.4315 0.00696193 51.3045L0.00292969 51.5525C0.00292969 78.3064 21.6964 99.9999 48.4544 99.9999C72.42 99.9999 92.3172 82.6008 96.2163 59.7521L96.4381 57.8831C97.3998 49.5767 96.3313 40.8408 93.293 33.5384H93.2889Z'
        fill='black'
      />
      <path
        d='M48.5448 42.2381C48.4641 43.4438 44.2101 47.601 42.7182 47.601C28.94 47.601 26.7041 55.9337 26.7041 55.9337C27.315 62.9498 32.2001 68.732 38.1154 71.7905C38.3855 71.9316 38.6597 72.0526 38.9319 72.1796C39.4007 72.3874 39.8753 72.5817 40.3553 72.7622C42.3841 73.4804 44.5092 73.8903 46.6597 73.978C70.8088 75.111 75.4902 45.1071 58.0609 36.3974C62.5225 35.6212 67.1536 37.4156 69.7423 39.2341C65.5084 31.8309 57.5951 26.835 48.5125 26.835C47.9379 26.835 47.3754 26.8833 46.8109 26.9217C41.9506 27.256 37.3038 29.0468 33.4763 32.0608C34.2142 32.6857 35.0488 33.5204 36.8029 35.2523C40.0891 38.4902 48.5226 41.845 48.5407 42.2381H48.5448Z'
        fill='black'
      />
      <path
        d='M93.2889 33.5385C91.1841 28.474 86.918 23.0063 83.5712 21.2764C86.297 26.6192 87.8736 31.982 88.4764 35.982L88.4865 36.0627C83.0067 22.4075 73.7184 16.8994 66.1318 4.90956L64.9906 3.05472C64.7998 2.72765 64.6216 2.3934 64.4564 2.05271C64.1415 1.44457 63.8986 0.801792 63.7326 0.137393C63.7338 0.105637 63.7231 0.0745619 63.7026 0.0503008C63.6821 0.0260397 63.6532 0.0103559 63.6217 0.00634532C63.592 -0.00211511 63.5606 -0.00211511 63.531 0.00634532L63.5068 0.0204582L63.4725 0.0406194L63.4926 0.0123937C51.3213 7.1414 47.1923 20.3268 46.8112 26.9276C41.9512 27.2614 37.3044 29.0515 33.4766 32.0647C33.0762 31.7262 32.6576 31.4099 32.2226 31.1171C31.1179 27.2537 31.0706 23.1645 32.0855 19.2764C27.1097 21.5426 23.2347 25.1232 20.4222 28.2885H20.4021C18.4807 25.8571 18.6158 17.8309 18.7246 16.1555C18.7045 16.0506 17.2932 16.8873 17.1077 17.0123C15.4125 18.2221 13.8277 19.5796 12.3718 21.0688C10.7155 22.749 9.20222 24.5644 7.84766 26.4962L7.84565 26.5022V26.4962C4.72992 30.911 2.52002 35.8996 1.34365 41.1736L1.27914 41.4961C1.10059 42.5011 0.941291 43.5093 0.801314 44.5203L0.791234 44.6252C0.366862 46.8316 0.104068 49.066 0.00494581 51.3106L0.00292969 51.5526C0.00292969 78.3065 21.6964 100 48.4544 100C72.42 100 92.3172 82.6008 96.2163 59.7521L96.4381 57.8832C97.3998 49.5768 96.3313 40.8409 93.293 33.5385H93.2889ZM37.4423 71.4618C37.6702 71.5686 37.8859 71.6876 38.1157 71.7924L38.148 71.8126C37.911 71.6993 37.6757 71.5823 37.4423 71.4618ZM88.4885 36.0728L88.4825 36.0264L88.4906 36.0788L88.4885 36.0728Z'
        fill='url(#paint0_linear_3788_42740)'
      />
      <path
        d='M93.2889 33.5384C91.1841 28.4739 86.918 23.0062 83.5712 21.2764C86.297 26.6191 87.8736 31.982 88.4764 35.982C88.4764 35.9699 88.4805 35.992 88.4845 36.0263L88.4926 36.0787C93.0651 48.4718 90.5732 61.0746 86.9845 68.7762C81.4321 80.6915 67.9926 92.9032 46.9504 92.3044C24.2166 91.6632 4.1884 74.7984 0.450509 52.7017C-0.230941 49.2178 0.450509 47.4497 0.79325 44.6211C0.375912 46.7985 0.216639 47.4315 0.00696193 51.3045L0.00292969 51.5525C0.00292969 78.3064 21.6964 99.9999 48.4544 99.9999C72.42 99.9999 92.3172 82.6008 96.2163 59.7521L96.4381 57.8831C97.3998 49.5767 96.3313 40.8408 93.293 33.5384H93.2889Z'
        fill='url(#paint1_radial_3788_42740)'
      />
      <path
        d='M93.2889 33.5384C91.1841 28.4739 86.918 23.0062 83.5712 21.2764C86.297 26.6191 87.8736 31.982 88.4764 35.982C88.4764 35.9699 88.4805 35.992 88.4845 36.0263L88.4926 36.0787C93.0651 48.4718 90.5732 61.0746 86.9845 68.7762C81.4321 80.6915 67.9926 92.9032 46.9504 92.3044C24.2166 91.6632 4.1884 74.7984 0.450509 52.7017C-0.230941 49.2178 0.450509 47.4497 0.79325 44.6211C0.375912 46.7985 0.216639 47.4315 0.00696193 51.3045L0.00292969 51.5525C0.00292969 78.3064 21.6964 99.9999 48.4544 99.9999C72.42 99.9999 92.3172 82.6008 96.2163 59.7521L96.4381 57.8831C97.3998 49.5767 96.3313 40.8408 93.293 33.5384H93.2889Z'
        fill='url(#paint2_radial_3788_42740)'
      />
      <path
        d='M69.7439 39.234L70.0464 39.4558C68.8303 37.2978 67.3161 35.3221 65.5484 33.5869C50.4859 18.5285 61.5948 0.933756 63.4698 0.0406139L63.4899 0.0144043C51.3186 7.1414 47.1896 20.3289 46.8105 26.9256C47.3751 26.8853 47.9396 26.8389 48.5122 26.8389C57.5948 26.8389 65.5081 31.8329 69.7419 39.2381L69.7439 39.234Z'
        fill='url(#paint3_radial_3788_42740)'
      />
      <path
        d='M48.5448 42.2381C48.4641 43.4438 44.2101 47.601 42.7182 47.601C28.94 47.601 26.7041 55.9337 26.7041 55.9337C27.315 62.9498 32.2001 68.732 38.1154 71.7905C38.3855 71.9316 38.6597 72.0526 38.9319 72.1796C39.4007 72.3874 39.8753 72.5817 40.3553 72.7622C42.3841 73.4804 44.5092 73.8903 46.6597 73.978C70.8088 75.111 75.4902 45.1071 58.0609 36.3974C62.5225 35.6212 67.1536 37.4156 69.7423 39.2341C65.5084 31.8309 57.5951 26.835 48.5125 26.835C47.9379 26.835 47.3754 26.8833 46.8109 26.9217C41.9506 27.256 37.3038 29.0468 33.4763 32.0608C34.2142 32.6857 35.0488 33.5204 36.8029 35.2523C40.0891 38.4902 48.5226 41.845 48.5407 42.2381H48.5448Z'
        fill='url(#paint4_radial_3788_42740)'
      />
      <path
        d='M48.5448 42.2381C48.4641 43.4438 44.2101 47.601 42.7182 47.601C28.94 47.601 26.7041 55.9337 26.7041 55.9337C27.315 62.9498 32.2001 68.732 38.1154 71.7905C38.3855 71.9316 38.6597 72.0526 38.9319 72.1796C39.4007 72.3874 39.8753 72.5817 40.3553 72.7622C42.3841 73.4804 44.5092 73.8903 46.6597 73.978C70.8088 75.111 75.4902 45.1071 58.0609 36.3974C62.5225 35.6212 67.1536 37.4156 69.7423 39.2341C65.5084 31.8309 57.5951 26.835 48.5125 26.835C47.9379 26.835 47.3754 26.8833 46.8109 26.9217C41.9506 27.256 37.3038 29.0468 33.4763 32.0608C34.2142 32.6857 35.0488 33.5204 36.8029 35.2523C40.0891 38.4902 48.5226 41.845 48.5407 42.2381H48.5448Z'
        fill='url(#paint5_radial_3788_42740)'
      />
      <path
        d='M31.2181 30.4518C31.5555 30.6695 31.8902 30.8913 32.2222 31.1171C31.1178 27.2528 31.0712 23.1629 32.0871 19.2744C27.1073 21.5426 23.2363 25.1212 20.4238 28.2865C20.6557 28.2804 27.6819 28.1534 31.2181 30.4518Z'
        fill='url(#paint6_radial_3788_42740)'
      />
      <path
        d='M0.44978 52.7016C4.18969 74.7983 24.2158 91.6632 46.9476 92.3063C67.9899 92.9031 81.4314 80.6894 86.9838 68.7782C90.5725 61.0766 93.0644 48.4758 88.4918 36.0807V36.0767L88.4838 36.0283C88.4797 35.994 88.4757 35.9718 88.4757 35.9839L88.4858 36.0646C90.2055 47.2863 84.4939 58.1572 75.5725 65.508L75.5463 65.5685C58.1573 79.7277 41.5182 74.1108 38.1472 71.8125C37.9105 71.6987 37.6752 71.5818 37.4416 71.4616C27.3045 66.6169 23.117 57.381 24.0142 49.4597C15.4558 49.4597 12.5364 42.242 12.5364 42.242C12.5364 42.242 20.2219 36.7622 30.3509 41.5263C39.7319 45.9416 48.5424 42.242 48.5424 42.24C48.5222 41.8468 40.0908 38.49 36.8045 35.2541C35.0464 33.5202 34.2138 32.6896 33.4739 32.0626C33.0734 31.7241 32.6548 31.4078 32.2198 31.115C31.8875 30.8897 31.5528 30.6679 31.2158 30.4497C27.6815 28.1513 20.6513 28.2803 20.4195 28.2864H20.3993C18.4779 25.8529 18.613 17.8267 18.7219 16.1493C18.7017 16.0485 17.2905 16.8812 17.105 17.0082C15.4098 18.218 13.825 19.5754 12.3691 21.0646C10.7128 22.7448 9.19948 24.5603 7.84492 26.492L7.8429 26.4981V26.492C4.72717 30.9069 2.51727 35.8954 1.34091 41.1694C1.32074 41.2742 -0.40304 48.7984 0.445748 52.7016H0.44978Z'
        fill='url(#paint7_radial_3788_42740)'
      />
      <path
        d='M65.5473 33.5889C67.3149 35.3235 68.8291 37.2985 70.0453 39.4558L70.7711 40.0526C81.759 50.1735 76.0009 64.488 75.5695 65.5082C84.4928 58.1574 90.2025 47.2864 88.4827 36.0647C83.007 22.4075 73.7187 16.8994 66.132 4.90956L64.9909 3.05472C64.8001 2.72765 64.6219 2.3934 64.4566 2.05271C64.1417 1.44457 63.8988 0.801792 63.7328 0.137393C63.7341 0.105637 63.7234 0.0745619 63.7029 0.0503008C63.6823 0.0260397 63.6535 0.0103559 63.6219 0.00634532C63.5923 -0.00211511 63.5609 -0.00211511 63.5312 0.00634532L63.507 0.0204582L63.4727 0.0406194C61.5977 0.933762 50.4889 18.5285 65.5493 33.5889H65.5473Z'
        fill='url(#paint8_radial_3788_42740)'
      />
      <path
        d='M70.7733 40.0506C70.5412 39.8406 70.299 39.6421 70.0475 39.4558L69.7451 39.234C67.1584 37.4195 62.5274 35.6211 58.0637 36.3974C75.491 45.111 70.8116 75.113 46.6625 73.9779C44.5121 73.8902 42.3869 73.4804 40.3581 72.7622C39.8782 72.5814 39.4036 72.3871 38.9347 72.1795C38.6593 72.0566 38.3871 71.9268 38.1182 71.7904L38.1504 71.8106C41.5173 74.1089 58.1584 79.7238 75.5495 65.5666L75.5757 65.5061C76.0051 64.486 81.7612 50.1715 70.7773 40.0506H70.7733Z'
        fill='url(#paint9_radial_3788_42740)'
      />
      <path
        d='M26.7043 55.9355C26.7043 55.9355 28.9422 47.6029 42.7184 47.6029C44.2103 47.6029 48.4644 43.4457 48.545 42.24C48.6256 41.0344 39.7345 45.9416 30.3535 41.5263C20.2245 36.7622 12.5391 42.24 12.5391 42.24C12.5391 42.24 15.4584 49.4577 24.0168 49.4577C23.1197 57.3811 27.3072 66.6149 37.4442 71.4597C37.672 71.5665 37.8837 71.6855 38.1176 71.7903C32.2003 68.7319 27.3152 62.9516 26.7064 55.9335L26.7043 55.9355Z'
        fill='url(#paint10_radial_3788_42740)'
      />
      <path
        d='M93.2889 33.5385C91.1841 28.474 86.918 23.0063 83.5712 21.2764C86.297 26.6192 87.8736 31.982 88.4764 35.982L88.4865 36.0627C83.0067 22.4075 73.7184 16.8994 66.1318 4.90956L64.9906 3.05472C64.7998 2.72765 64.6216 2.3934 64.4564 2.05271C64.1415 1.44457 63.8986 0.801792 63.7326 0.137393C63.7338 0.105637 63.7231 0.0745619 63.7026 0.0503008C63.6821 0.0260397 63.6532 0.0103559 63.6217 0.00634532C63.592 -0.00211511 63.5606 -0.00211511 63.531 0.00634532L63.5068 0.0204582L63.4725 0.0406194L63.4926 0.0123937C51.3213 7.1414 47.1923 20.3268 46.8112 26.9276C47.3758 26.8873 47.9403 26.8409 48.5149 26.8409C57.5975 26.8409 65.5108 31.8349 69.7446 39.2361C67.1559 37.4215 62.5269 35.6232 58.0612 36.3994C75.4886 45.1131 70.8092 75.115 46.66 73.9799C44.5096 73.8922 42.3845 73.4824 40.3556 72.7642C39.8758 72.5835 39.4011 72.3892 38.9322 72.1815C38.6569 72.0586 38.3846 71.9288 38.1157 71.7924L38.15 71.8126C37.9132 71.6988 37.678 71.5819 37.4443 71.4618C37.6702 71.5686 37.8839 71.6876 38.1157 71.7924C32.1984 68.734 27.3133 62.9537 26.7045 55.9356C26.7045 55.9356 28.9383 47.603 42.7165 47.603C44.2084 47.603 48.4625 43.4457 48.5431 42.2401C48.5229 41.8469 40.0955 38.4901 36.8052 35.2542C35.0512 33.5204 34.2145 32.6897 33.4786 32.0627C33.0775 31.7242 32.6582 31.4078 32.2226 31.1151C31.1186 27.2515 31.0719 23.1623 32.0875 19.2744C27.1077 21.5406 23.2367 25.1212 20.4242 28.2865H20.4041C18.4827 25.853 18.6178 17.8289 18.7267 16.1494C18.7065 16.0486 17.2952 16.8813 17.1097 17.0083C15.4145 18.2181 13.8297 19.5755 12.3739 21.0647C10.7182 22.745 9.20561 24.5605 7.8517 26.4921L7.84968 26.4982V26.4921C4.73395 30.907 2.52405 35.8955 1.34768 41.1695L1.28317 41.4921C1.07732 42.5065 0.891132 43.5249 0.724702 44.5465C0.720669 44.5828 0.728734 44.5123 0.724702 44.5465C0.350333 46.7834 0.111324 49.0409 0.00897806 51.3066L0.00292969 51.5526C0.00292969 78.3065 21.6964 100 48.4544 100C72.42 100 92.3172 82.6008 96.2163 59.7521L96.4381 57.8832C97.3998 49.5768 96.3313 40.8409 93.293 33.5385H93.2889ZM88.4825 36.0264L88.4906 36.0788V36.0748L88.4825 36.0264Z'
        fill='url(#paint11_linear_3788_42740)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_3788_42740'
          x1='84.4414'
          y1='15.5'
          x2='6.64136'
          y2='90.5513'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.05' stopColor='#FFF44F' />
          <stop offset='0.37' stopColor='#FF980E' />
          <stop offset='0.53' stopColor='#FF3647' />
          <stop offset='0.7' stopColor='#E31587' />
        </linearGradient>
        <radialGradient
          id='paint1_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(67.0251 11.1213) scale(99.1003 100.766)'
        >
          <stop offset='0.13' stopColor='#FFBD4F' />
          <stop offset='0.28' stopColor='#FF980E' />
          <stop offset='0.47' stopColor='#FF3750' />
          <stop offset='0.78' stopColor='#EB0878' />
          <stop offset='0.86' stopColor='#E50080' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(38.3077 52.7658) scale(101.578 100.766)'
        >
          <stop offset='0.3' stopColor='#960E18' />
          <stop offset='0.35' stopColor='#B11927' stopOpacity='0.74' />
          <stop offset='0.43' stopColor='#DB293D' stopOpacity='0.34' />
          <stop offset='0.5' stopColor='#F5334B' stopOpacity='0.1' />
          <stop offset='0.53' stopColor='#FF3750' stopOpacity='0' />
        </radialGradient>
        <radialGradient
          id='paint3_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(57.9637 -4.71857) scale(32.5301 55.218)'
        >
          <stop offset='0.13' stopColor='#FFF44F' />
          <stop offset='0.53' stopColor='#FF980E' />
        </radialGradient>
        <radialGradient
          id='paint4_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(36.4996 78.7785) scale(43.0382 47.1742)'
        >
          <stop offset='0.35' stopColor='#3A8EE6' />
          <stop offset='0.67' stopColor='#9059FF' />
          <stop offset='1' stopColor='#C139E6' />
        </radialGradient>
        <radialGradient
          id='paint5_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(43.8532 42.4025) scale(22.8533 27.8328)'
        >
          <stop offset='0.21' stopColor='#9059FF' stopOpacity='0' />
          <stop offset='0.97' stopColor='#6E008B' stopOpacity='0.6' />
        </radialGradient>
        <radialGradient
          id='paint6_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(45.2004 7.43171) scale(34.2152 34.3438)'
        >
          <stop offset='0.1' stopColor='#FFE226' />
          <stop offset='0.79' stopColor='#FF7139' />
        </radialGradient>
        <radialGradient
          id='paint7_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(76.4505 -15.0956) scale(163.371 137.136)'
        >
          <stop offset='0.11' stopColor='#FFF44F' />
          <stop offset='0.46' stopColor='#FF980E' />
          <stop offset='0.72' stopColor='#FF3647' />
          <stop offset='0.9' stopColor='#E31587' />
        </radialGradient>
        <radialGradient
          id='paint8_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(15.5924 30.0533) rotate(77.3945) scale(51.8218 224.213)'
        >
          <stop stopColor='#FFF44F' />
          <stop offset='0.3' stopColor='#FF980E' />
          <stop offset='0.57' stopColor='#FF3647' />
          <stop offset='0.74' stopColor='#E31587' />
        </radialGradient>
        <radialGradient
          id='paint9_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(45.5545 19.7858) scale(93.8001 92.1411)'
        >
          <stop offset='0.14' stopColor='#FFF44F' />
          <stop offset='0.48' stopColor='#FF980E' />
          <stop offset='0.66' stopColor='#FF3647' />
          <stop offset='0.9' stopColor='#E31587' />
        </radialGradient>
        <radialGradient
          id='paint10_radial_3788_42740'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(69.8974 25.1746) scale(112.736 100.853)'
        >
          <stop offset='0.09' stopColor='#FFF44F' />
          <stop offset='0.63' stopColor='#FF980E' />
        </radialGradient>
        <linearGradient
          id='paint11_linear_3788_42740'
          x1='77.425'
          y1='14'
          x2='15.2123'
          y2='81.9768'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.17' stopColor='#FFF44F' stopOpacity='0.8' />
          <stop offset='0.6' stopColor='#FFF44F' stopOpacity='0' />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
}
